(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('AssignUserFormCtrl', AssignUserFormCtrl)
	AssignUserFormCtrl.$inject = [
		'$rootScope',
		'$scope',
		'$uibModalInstance',
		'items',
		'UserService',
		'EventService',
		"$controller"
	];
		function AssignUserFormCtrl(
			$rootScope,
			$scope,
			$uibModalInstance,
			items,
			UserService,
			EventService,
			$controller
		){

			var ctrl = this;

			//Get the default functionality for modal form
			var base = $controller('BaseFormCtrl', {$scope: $scope});

			angular.extend(this, base);

			if((items != undefined)&&(items.bind != undefined)) {
				ctrl.bind = items.bind;
				ctrl.originalObj = angular.extend({}, items.bind);
			}

			if((items != undefined)&&(items.expect != undefined)) {
				ctrl.expectEvent = items.expect;
			}

			// Properties
			ctrl.responsibleUser = {};
			ctrl.requestorUser = {};
			ctrl.assignedUser = {};
			ctrl.originalObj = {
				lead:''
			}

			ctrl.addUser = function(){
				var data = ctrl.bind
				UserService.addUser(data)
				.then(function(res){
					ctrl.users.push(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM addUser: ", err);
				});
			}

			ctrl.getUsers = function(){
				UserService.getAllUsers()
				.then(function(res){
					ctrl.userList = res;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM addUser: ", err);
				});
			}

			ctrl.getCoordinators = function(roleName){
				UserService.getAllUsersByRole(roleName)
				.then(function(res){
					ctrl.coordinators = res;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM addUser: ", err);
				});
			}

			ctrl.updateCoordinator = function(){
				var data = {
					coordinator_id: ctrl.coordinatorUser.originalObject.id,
					// responsible_user_id: ctrl.leadUser.originalObject.id
				};
				EventService.updateEventAdmin(ctrl.bind.uid, data)
				.then(function(res){
					ctrl.fireEvents(res);
					$uibModalInstance.close(ctrl.bind);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM updateUser: ", err);
				});
			}

			ctrl.deleteUser = function(userId, idx){
				var data = ctrl.bind
				UserService.deleteUser(userId)
				.then(function(res){
					ctrl.users.splice(idx, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deleteUser: ", err);
				});
			}

			ctrl.prospectiveCoordinators = function(){
				return ctrl.coordinators.filter(function(i){
					return i.email != ctrl.originalObj.lead.email;
				});
			}

			ctrl.fireEvents = function (d) {
				if (ctrl.expectEvent != undefined && ctrl.expectEvent != '') {
					$rootScope.$emit(ctrl.expectEvent, d);
				} else {
					//
				}
			}

			$scope.ok = ctrl.ok;

			ctrl.cancel = function () {
				$uibModalInstance.dismiss('cancel');
			};

			$scope.cancel = ctrl.cancel;
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('EquipmentCtrl', EquipmentCtrl)
	EquipmentCtrl.$inject = [
		"$rootScope",
		"$scope",
		"EquipmentService",
		"$controller"
	];
	function EquipmentCtrl(
		$rootScope,
		$scope,
		EquipmentService,
		$controller
	){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-2','field':'label','title':'Label'},
			{'class':'col-md-2','field':'instructions','title':'Instructions'},
			{'class':'col-md-2','field':'details','title':'Details'},
			{'class':'col-md-2','field':'count','title':'Count'},
			{'class':'col-md-2','field':'qty_max','title':'Qty Max'},
			{'class':'col-md-2','field':'qty_over','title':'Qty Over'},
			{'class':'col-md-2','field':'amount','title':'Amount'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-5','field':'label','title':'Label'},
			{'class':'col-md-2','field':'count','title':'Count'},
			{'class':'col-md-2','field':'qty_over','title':'Extra'},
			{'class':'col-md-2','field':'amount','title':'Charge'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.equipment			= [];
		ctrl.isTabulated= true;
		ctrl.showSearch = false;
		ctrl.totalPrice = 0;


		// get all Equipment
		ctrl.getEquipment = function(){
			EquipmentService.getAllEquipment(ctrl.searchDB)
			.then(function(res){
				ctrl.equipment = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.equipmentCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getEquipment: ", err);
			});
		}

		// get all Equipment for a specific parent
		ctrl.getParentEquipment = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			EquipmentService.getAllEquipmentByParent(parentId,parentType)
			.then(function(res){
				ctrl.equipment = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getEquipment: ", err);
			});
		}

		// get a specific Equipment
		ctrl.getEquipment = function(equipmentId){
			EquipmentService.getEquipment(equipmentId)
			.then(function(res){
				ctrl.equipment = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getEquipment: ", err);
			});
		}

		// delete a specific Equipment
		ctrl.deleteEquipment= function (equipment){
			if(confirm('Are you sure you want to delete this equipment?')){
				EquipmentService.deleteEquipment(equipment.uid)
				.then(function(res){
					var position = ctrl.equipment.map(function(equipment){
						return equipment.id;
					}).indexOf(equipment.id);
					ctrl.equipment.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deleteEquipment: ", err);
				});
			}
		}

		ctrl.emptyFilter = function(equipment) {
			if (equipment.count == 0) {
				return equipment;
			}
		};

		// Search all Equipment
        ctrl.getChargeTotal = function () {
			ctrl.totalPrice = 0;
			angular.forEach(ctrl.equipment, function (equipment, key) {
				ctrl.totalPrice += parseFloat(equipment.amount * equipment.qty_over);
			});
			return ctrl.totalPrice.toFixed(2);
		}

		// Events Listeners
		var createListener = $rootScope.$on('EquipmentCtrl.create', function (event, data) {
			ctrl.equipment.push(data.payload);
		});
		var updateListener = $rootScope.$on('EquipmentCtrl.update', function (event, data) {
			var position = ctrl.equipment.map(function(equipment){
				return equipment.id;
			}).indexOf(data.id);
			ctrl.equipment[position] = data;
		});
		var refreshListener = $rootScope.$on('EquipmentCtrl.refresh', function (event, data) {
			ctrl.getParentEquipment(ctrl.parentId, ctrl.parentType);
		});
		var deleteListener = $rootScope.$on('EquipmentCtrl.destroy', function (event, data) {
			var position = ctrl.equipment.map(function(equipment){
				return equipment.id;
			}).indexOf(data.object.id);
			ctrl.equipment.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('EquipmentFormCtrl', EquipmentFormCtrl)
	EquipmentFormCtrl.$inject = [
		'$rootScope',
		'$scope',
		'$uibModalInstance',
		'items',
		'EquipmentService',
		"$controller"
	];
	function EquipmentFormCtrl(
		$rootScope,
		$scope,
		$uibModalInstance,
		items,
		EquipmentService,
		$controller
	){

		var ctrl = this;

		//Get the default functionality for modal form
		var base = $controller('BaseFormCtrl', {$scope: $scope});

		angular.extend(this, base);

		if((items != undefined)&&(items.bind != undefined)) {
			ctrl.bind = items.bind;
			ctrl.originalObj = angular.extend({}, items.bind);
		}

		if((items != undefined)&&(items.expect != undefined)) {
			ctrl.expectEvent = items.expect;
		}

		ctrl.addEquipment = function(){
			var data = ctrl.bind
			EquipmentService.addEquipment(data)
			.then(function(res){
				ctrl.equipment.push(res);
				ctrl.fireEvents(res);
			})
			.catch(function(err){
				if(err.status == 422) {
					ctrl.notSubmitted = true;
					ctrl.errors = ctrl.processErrors(err.data)
					ctrl.submitDisabled = false;
				}
				ctrl.hasError = true;
				console.error("ERROR RESPONDING FROM addEquipment: ", err);
			});
		}

		ctrl.updateEquipment= function(){
			var data = ctrl.bind
			if(ctrl.assigned_parent.originalObject != undefined) {
				data.parent_id = ctrl.assigned_parent.originalObject.id
			}
			EquipmentService.updateEquipment(ctrl.bind.uid, data)
			.then(function(res){
				$uibModalInstance.close(ctrl.bind);
			})
			.catch(function(err){
				if(err.status == 422) {
					ctrl.notSubmitted = true;
					ctrl.errors = ctrl.processErrors(err.data)
					ctrl.submitDisabled = false;
				}
				ctrl.hasError = true;
				console.error("ERROR RESPONDING FROM updateEquipment: ", err);
			});
		}

		ctrl.deleteEquipment = function(equipment){
			var data = ctrl.bind
			EquipmentService.deleteEquipment(equipment.uid)
			.then(function(res){
				var position = ctrl.equipment.map(function(equipment){
					return equipment.id;
				}).indexOf(data.object.id);
				ctrl.equipment.splice(position,1);
			})
			.catch(function(err){
				if(err.status == 422) {
					ctrl.notSubmitted = true;
					ctrl.errors = ctrl.processErrors(err.data)
					ctrl.submitDisabled = false;
				}
				ctrl.hasError = true;
				console.error("ERROR RESPONDING FROM deleteEquipment: ", err);
			});
		}

		ctrl.fireEvents = function (d) {
			if (ctrl.expectEvent != undefined && ctrl.expectEvent != '') {
				$rootScope.$emit(ctrl.expectEvent, d);
			} else {
				//
			}
		}

		ctrl.calculateQty = function () {
			var difference = ctrl.bind.qty_max - ctrl.bind.count;
			console.log('calculateQty difference: ',difference);
			if (difference >= 0) {
				ctrl.bind.qty_over = 0
				return;
			}
			if (difference < 0) {
				ctrl.bind.qty_over = Math.abs(difference);
				return;
			}
		}

		$scope.ok = ctrl.ok = ctrl.updateEquipment;

		$scope.cancel = function () {
			if(ctrl.bind != undefined) {
				// angular.extend(ctrl.bind, originalObj);
			}
			$uibModalInstance.dismiss('cancel');
		};
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('EventCtrl', EventCtrl)
	EventCtrl.$inject = [
		"$rootScope",
		"$scope",
		"EventService",
		"$controller"
	];
	function EventCtrl(
		$rootScope,
		$scope,
		EventService,
		$controller
	){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-1','field':'status','title':'Status'},
			{'class':'col-md-2','field':'coordinator','title':'Coordinator'},
			{'class':'col-md-2','field':'event_type','title':'Event Type'},
			{'class':'col-md-2','field':'starts_at','title':'When'},
			{'class':'col-md-1','field':'event_guest_count','title':'Event Guest Count'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-3','field':'name','title':'Name'},
			{'class':'col-md-2','field':'status','title':'Status'},
			{'class':'col-md-2','field':'event_type','title':'Event Type'},
			{'class':'col-md-2','field':'starts_at','title':'When'},
			{'class':'col-md-1','field':'event_guest_count','title':'Guest Count'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.events			= [];
		ctrl.event			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Events
		ctrl.getEvents = function(){
			EventService.getAllEvents(ctrl.searchDB)
			.then(function(res){
				ctrl.events = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.eventCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getEvents: ", err);
			});
		}

		// get all Events for a specific parent
		ctrl.getParentEvents = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			EventService.getAllEventsByParent(parentId,parentType)
			.then(function(res){
				ctrl.events = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getEvents: ", err);
			});
		}

		// get a specific Event
		ctrl.getEvent = function(eventId){
			EventService.getEvent(eventId)
			.then(function(res){
				ctrl.event = res;
				ctrl.setSecondaryObjects();
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getEvents: ", err);
			});
		}

		// delete a specific Event
		ctrl.deleteEvent= function (event){
			if(confirm('Are you sure you want to delete this event?')){
				EventService.deleteEvent(event.uid)
				.then(function(res){
					var position = ctrl.events.map(function(event){
						return event.id;
					}).indexOf(event.id);
					ctrl.events.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deleteEvent: ", err);
				});
			}
		}

		// Search all Events
		ctrl.searchEvents = function(){
			EventService.getAllEvents(ctrl.searchDB)
			.then(function(res){
				ctrl.events = res.data;
				ctrl.eventCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchEvents: ", err);
			});
		}

		// Search all Events
		ctrl.setSecondaryObjects = function(){
			ctrl.eventArrival = {
				id: ctrl.event.id,
				starts_at: ctrl.event.starts_at,
				ends_at: ctrl.event.ends_at,
				arrive_at: ctrl.event.arrive_at,
				depart_at: ctrl.event.depart_at
			}

			ctrl.eventItenerary = {
				id: ctrl.event.id,
				itinerary: ctrl.event.itinerary,
			}

		}

		// Events Listeners
		var createListener = $rootScope.$on('EventCtrl.create', function (event, data) {
			ctrl.events.push(data.payload);
		});
		var updateListener = $rootScope.$on('EventCtrl.update', function (event, data) {
			var position = ctrl.events.map(function(event){
				return event.id;
			}).indexOf(data.id);
			ctrl.events[position] = data;
		});
		var refreshListener = $rootScope.$on('EventCtrl.refresh', function (event, data) {
			ctrl.getEvent(ctrl.event.uid);
			ctrl.setSecondaryObjects();
			$rootScope.$emit('EquipmentCtrl.refresh', data);
			$rootScope.$emit('NoteCtrl.refresh', data);
		});
		var updateCoordinatorListener = $rootScope.$on('EventCtrl.updateCoordinator', function (event, data) {
			console.log('updateCoordinator data: ',data);
			ctrl.event.coordinator = data.coordinator;
		});
		var deleteListener = $rootScope.$on('EventCtrl.destroy', function (event, data) {
			var position = ctrl.events.map(function(event){
				return event.id;
			}).indexOf(data.object.id);
			ctrl.events.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('EventFormController', EventFormController)
	EventFormController.$inject = [
		'$rootScope',
		'$scope',
		'$uibModalInstance',
		'$window',
		'items',
		'EventService',
		"$controller"
	];
	function EventFormController(
		$rootScope,
		$scope,
		$uibModalInstance,
		$window,
		items,
		EventService,
		$controller
	){

		var ctrl = this;

		//Get the default functionality for modal form
		var base = $controller('BaseFormCtrl', {$scope: $scope});

		angular.extend(this, base);

		if((items != undefined)&&(items.bind != undefined)) {
			ctrl.bind = items.bind;
			ctrl.originalObj = angular.extend({}, items.bind);
		}

		if((items != undefined)&&(items.expect != undefined)) {
			ctrl.expectEvent = items.expect;
		}

		ctrl.addEvent = function(){
			var data = ctrl.bind
			EventService.addEvent(data)
			.then(function(res){
				if(res.redirect != undefined) {
					$window.location.href = res.redirect;
				}
				$uibModalInstance.close(ctrl.bind);
})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM addEvent: ", err);
			});
		}

		ctrl.updateEvent= function(){
			var data = ctrl.bind
			EventService.updateEvent(ctrl.bind.uid, data)
			.then(function(res){
				$uibModalInstance.close(ctrl.bind);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM updateEvent: ", err);
			});
		}

		ctrl.deleteEvent = function(event){
			var data = ctrl.bind
			EventService.deleteEvent(event.uid)
			.then(function(res){
				var position = ctrl.events.map(function(event){
					return event.id;
				}).indexOf(data.object.id);
				ctrl.events.splice(position,1);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM deleteEvent: ", err);
			});
		}

		ctrl.fireEvents = function (d) {
			if (ctrl.expectEvent != undefined && ctrl.expectEvent != '') {
				$rootScope.$emit(ctrl.expectEvent, d);
			} else {
				//
			}
		}

		ctrl.setNameField = function () {
			ctrl.bind.name = ctrl.bind.spouse_1_last_name + '/' + ctrl.bind.spouse_2_last_name
		}

		$scope.ok = ctrl.ok = ctrl.addEvent;

		$scope.cancel = function () {
			if(ctrl.bind != undefined) {
				// angular.extend(ctrl.bind, originalObj);
			}
			$uibModalInstance.dismiss('cancel');
		};
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('NoteCtrl', NoteCtrl)
	NoteCtrl.$inject = [
		"$rootScope",
		"$scope",
		"NoteService",
		"$controller"
	];
	function NoteCtrl(
		$rootScope,
		$scope,
		NoteService,
		$controller
	){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-2','field':'label','title':'Label'},
			{'class':'col-md-2','field':'instructions','title':'Instructions'},
			{'class':'col-md-2','field':'details','title':'Details'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-2','field':'label','title':'Label'},
			{'class':'col-md-2','field':'instructions','title':'Instructions'},
			{'class':'col-md-2','field':'details','title':'Details'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.notes			= [];
		ctrl.note			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Notes
		ctrl.getNotes = function(){
			NoteService.getAllNotes(ctrl.searchDB)
			.then(function(res){
				ctrl.notes = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.noteCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getNotes: ", err);
			});
		}

		// get all Notes for a specific parent
		ctrl.getParentNotes = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			NoteService.getAllNotesByParent(parentId,parentType)
			.then(function(res){
				ctrl.notes = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getNotes: ", err);
			});
		}

		// get a specific Note
		ctrl.getNote = function(noteId){
			NoteService.getNote(noteId)
			.then(function(res){
				ctrl.note = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getNotes: ", err);
			});
		}

		// delete a specific Note
		ctrl.deleteNote= function (note){
			if(confirm('Are you sure you want to delete this note?')){
				NoteService.deleteNote(note.uid)
				.then(function(res){
					var position = ctrl.notes.map(function(note){
						return note.id;
					}).indexOf(note.id);
					ctrl.notes.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deleteNote: ", err);
				});
			}
		}

		ctrl.emptyFilter = function(note) {
			if (note.details?.constructor === undefined) {
				return note;
			}
		};

		// Search all Notes
		ctrl.searchNotes = function(){
			NoteService.getAllNotes(ctrl.searchDB)
			.then(function(res){
				ctrl.notes = res.data;
				ctrl.noteCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchNotes: ", err);
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('NoteCtrl.create', function (event, data) {
			ctrl.notes.push(data.payload);
		});
		var updateListener = $rootScope.$on('NoteCtrl.update', function (event, data) {
			var position = ctrl.notes.map(function(note){
				return note.id;
			}).indexOf(data.id);
			ctrl.notes[position] = data;
		});
		var refreshListener = $rootScope.$on('NoteCtrl.refresh', function (event, data) {
			ctrl.getParentNotes(ctrl.parentId, ctrl.parentType);
		});
		var deleteListener = $rootScope.$on('NoteCtrl.destroy', function (event, data) {
			var position = ctrl.notes.map(function(note){
				return note.id;
			}).indexOf(data.object.id);
			ctrl.notes.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('PreferenceCtrl', PreferenceCtrl)
	PreferenceCtrl.$inject = [
		"$rootScope",
		"$scope",
		"PreferenceService",
		"$controller"
	];
	function PreferenceCtrl(
		$rootScope,
		$scope,
		PreferenceService,
		$controller
	){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-2','field':'label','title':'Label'},
			{'class':'col-md-2','field':'value','title':'Value'},
			{'class':'col-md-2','field':'description','title':'Description'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-2','field':'label','title':'Label'},
			{'class':'col-md-2','field':'value','title':'Value'},
			{'class':'col-md-2','field':'description','title':'Description'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.preferences			= [];
		ctrl.preference			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Preferences
		ctrl.getPreferences = function(){
			PreferenceService.getAllPreferences(ctrl.searchDB)
			.then(function(res){
				ctrl.preferences = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.preferenceCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getPreferences: ", err);
			});
		}

		// get all Preferences for a specific parent
		ctrl.getParentPreferences = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			PreferenceService.getAllPreferencesByParent(parentId,parentType)
			.then(function(res){
				ctrl.preferences = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getPreferences: ", err);
			});
		}

		// get a specific Preference
		ctrl.getPreference = function(preferenceId){
			PreferenceService.getPreference(preferenceId)
			.then(function(res){
				ctrl.preference = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getPreferences: ", err);
			});
		}

		// delete a specific Preference
		ctrl.deletePreference= function (preference){
			if(confirm('Are you sure you want to delete this preference?')){
				PreferenceService.deletePreference(preference.uid)
				.then(function(res){
					var position = ctrl.preferences.map(function(preference){
						return preference.id;
					}).indexOf(preference.id);
					ctrl.preferences.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deletePreference: ", err);
				});
			}
		}

		// Search all Preferences
		ctrl.searchPreferences = function(){
			PreferenceService.getAllPreferences(ctrl.searchDB)
			.then(function(res){
				ctrl.preferences = res.data;
				ctrl.preferenceCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchPreferences: ", err);
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('PreferenceCtrl.create', function (event, data) {
			ctrl.preferences.push(data.payload);
		});
		var updateListener = $rootScope.$on('PreferenceCtrl.update', function (event, data) {
			var position = ctrl.preferences.map(function(preference){
				return preference.id;
			}).indexOf(data.id);
			ctrl.preferences[position] = data;
		});
		var deleteListener = $rootScope.$on('PreferenceCtrl.destroy', function (event, data) {
			var position = ctrl.preferences.map(function(preference){
				return preference.id;
			}).indexOf(data.object.id);
			ctrl.preferences.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function () {
	'use strict';
	angular
		.module('myApp')
		.controller('UserCtrl', UserCtrl)
	UserCtrl.$inject = [
		"$rootScope",
		"$scope",
		"UserService",
		"RoleService",
		"$controller"
	];
	function UserCtrl(
		$rootScope,
		$scope,
		UserService,
		RoleService,
		$controller
	) {

		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', { $scope: $scope });

		angular.extend(this, base)

		//member data
		ctrl.roles = [],
			ctrl.columns = [
			{ 'class': 'col-sm-2', 'field': 'fullname', 'title': 'Name' },
			{ 'class': 'col-sm-2', 'field': 'email', 'title': 'Email' },
			{ 'class': 'col-sm-2', 'field': 'mobile_number', 'title': 'Mobile' },
			{ 'class': 'col-sm-4', 'field': 'registered_at', 'title': 'Registered Date' }
		];
		ctrl.modColumns = [
			{ 'class': 'col-sm-2', 'field': 'fullname', 'title': 'Name' },
			{ 'class': 'col-sm-2', 'field': 'email', 'title': 'Email' },
			{ 'class': 'col-sm-2', 'field': 'mobile_number', 'title': 'Mobile' },
			{ 'class': 'col-sm-4', 'field': 'created_at', 'title': 'Registered Date' }
		];
		ctrl.isTabulated = true;
		ctrl.showSearch = true;

		//methods
		ctrl.loadUsers = function () {
			ctrl.isLoaded = false;
			UserService.getAllUsers()
				.then(function (res) {
					ctrl.users = res.data;
					ctrl.userCount = res.count;
					ctrl.loadRoles();
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getDepartments: ", err);
				});
		}

		ctrl.loadUser = function (userId) {
			ctrl.userId = userId;
			UserService.getUser(ctrl.userId)
				.then(function (res) {
					ctrl.user = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getUser: ", err);
				});
		};

		// get all Users for a specific parent
		ctrl.getUsersModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			UserService.getAllUsersByParent(parentId,parentType)
			.then(function(res){
				ctrl.users = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getUsers: ", err);
			});
		}

		ctrl.loadRoles = function () {
			ctrl.isLoaded = false;
			RoleService.getAllRoles()
				.then(function (res) {
					ctrl.roles = res;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getDepartments: ", err);
				});
		}
		// Search all Donors
		ctrl.searchUsers = function () {
			UserService.getAllUsers(ctrl.searchDB)
				.then(function (res) {
					ctrl.users = res.data;
					ctrl.userCount = res.count;
					ctrl.searchQry.$ = '';
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM searchUsers: ", err);
				});
		}


		ctrl.deleteUser = function (user) {
			if (confirm('Are you certain you want to delete this user?')) {
				UserService.deleteUser(user.uid)
					.then(function (res) {
						var position = ctrl.users.map(function(user){
							return user.id;
						}).indexOf(res.id);
						ctrl.users.splice(position, 1);
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM deleteUser: ", err);
					});
			}
		}

		ctrl.changeUserPermission = function (role, user) {

			var permission = user.permissions[role.name] ? false : true;

			var post_data = {
				'user_id': user.id,
				'role_id': role.id,
			};
			// if this is true, we should be removing it
			if (!permission) {
				UserService.detachRole(post_data)
					.then(function (res) {
						user.permissions[role.name] = false;
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM attachRole: ", err);
						user.permissions[role.name] = true;
					});
			} else {
				UserService.attachRole(post_data)
					.then(function (res) {
						user.permissions[role.name] = true;
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM attachRole: ", err);
						user.permissions[role.name] = false;
					});
			}
		};

		// delete a specific Engagement
		ctrl.remove = function (user, parentId, parentType){
			if(confirm('Are you sure you want to remove this user?')){
				var data = {
					parentId:parentId,
					parentType:parentType,
					userId:user.id,
				};
				// return
				UserService.detachUserFromParent(data)
				.then(function(res){
					var position = ctrl.users.map(function(user){
						return user.id;
					}).indexOf(res.id);
					ctrl.users.splice(position, 1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}
		// Events Listener
		var createListener = $rootScope.$on('UserCtrl.create', function (event, data) {
			ctrl.users.push(data.payload);
		});
		var updateListener = $rootScope.$on('UserCtrl.update', function (event, data) {
			//do nothing
		});
		var deleteListener = $rootScope.$on('UserCtrl.delete', function (event, data) {
			var position = ctrl.users.map(function(user){
				return user.id;
			}).indexOf(data.id);
			ctrl.users.splice(position, 1);
		});
		var reloadListener = $rootScope.$on('UserCtrl.reload', function (event, data) {
			ctrl.loadUser(ctrl.userId);
		});

		$scope.$on('$destroy', function () {
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('VendorCtrl', VendorCtrl)
	VendorCtrl.$inject = [
		"$rootScope",
		"$scope",
		"VendorService",
		"$controller"
	];
	function VendorCtrl(
		$rootScope,
		$scope,
		VendorService,
		$controller
	){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-1','field':'status','title':'Status'},
			{'class':'col-md-1','field':'category','title':'Category'},
			{'class':'col-md-2','field':'email','title':'Email'},
			{'class':'col-md-2','field':'phone','title':'Phone'},
			{'class':'col-md-3','field':'address','title':'Address'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'category','title':'Category'},
			{'class':'col-md-6','field':'name','title':'Name'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.vendors			= [];
		ctrl.vendor			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Vendors
		ctrl.getVendors = function(){
			VendorService.getAllVendors(ctrl.searchDB)
			.then(function(res){
				ctrl.vendors = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.vendorCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getVendors: ", err);
			});
		}

		// get all Vendors for a specific parent
		ctrl.getParentVendors = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			VendorService.getAllVendorsByParent(parentId,parentType)
			.then(function(res){
				ctrl.vendors = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getVendors: ", err);
			});
		}

		// get a specific Vendor
		ctrl.getVendor = function(vendorId){
			VendorService.getVendor(vendorId)
			.then(function(res){
				ctrl.vendor = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getVendors: ", err);
			});
		}

		// delete a specific Vendor
		ctrl.deleteVendor= function (vendor){
			if(confirm('Are you sure you want to delete this vendor?')){
				VendorService.deleteVendor(vendor.uid)
				.then(function(res){
					var position = ctrl.vendors.map(function(vendor){
						return vendor.id;
					}).indexOf(vendor.id);
					ctrl.vendors.splice(position, 1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deleteVendor: ", err);
				});
			}
		}

		// delete a specific Vendor
		ctrl.detachVendor = function (vendor){
			if(confirm('Are you sure you want to remove this vendor?')){
				var data = {
					parentId:ctrl.parentId,
					parentType:ctrl.parentType,
					vendorId:vendor.id
				}
				console.log('detachVendor data: ',data);
				// return;
				VendorService.detachVendorFromParent(data)
				.then(function(res){
					var position = ctrl.vendors.map(function(vendor){
						return vendor.id;
					}).indexOf(vendor.id);
					ctrl.vendors.splice(position, 1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM detachVendor: ", err);
				});
			}
		}

		// Search all Vendors
		ctrl.attachVendor = function(){
			var data = {
				parentId:ctrl.parentId,
				parentType:ctrl.parentType,
				vendorId:ctrl.new_vendor
			}
			console.log('attachVendor data:',data);
			// return;
			VendorService.attachVendorToParent(data)
			.then(function(res){
				ctrl.new_vendor = '';
				ctrl.vendors.push(res);
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchVendors: ", err);
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('VendorCtrl.create', function (event, data) {
			ctrl.vendors.push(data.payload);
		});
		var updateListener = $rootScope.$on('VendorCtrl.update', function (event, data) {
			var position = ctrl.vendors.map(function(vendor){
				return vendor.id;
			}).indexOf(data.id);
			ctrl.vendors[position] = data;
		});
		var deleteListener = $rootScope.$on('VendorCtrl.destroy', function (event, data) {
			var position = ctrl.vendors.map(function(vendor){
				return vendor.id;
			}).indexOf(data.object.id);
			ctrl.vendors.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
//# sourceMappingURL=controllers.js.map
